export default "__VITE_ASSET__6cpX_jxH__"